import React, { Fragment } from 'react';
import { NavLink } from 'react-router-dom';
import IntlMessages from 'util/IntlMessages';

const SidenavAdminContent = () => {
    return (
        <Fragment>
            <li className="menu">
                <a role="button" href="javascript:void(0)" onClick={(e) => this.linkClick(e)}>
                    <i className="zmdi zmdi-menu zmdi-hc-fw" />
                    <span className="nav-text">
                        <IntlMessages id="sidebar.agile.dashboards" />
                    </span>
                </a>
                <ul className="sub-menu">
                    <li className="menu no-arrow">
                        <NavLink to="/app/org-dashboard/default">
                            <i className="zmdi zmdi-check-square zmdi-hc-fw" />
                            <span className="nav-text">
                                <IntlMessages id="sidebar.agile.dashboard" />
                            </span>
                        </NavLink>
                    </li>
                    <li className="menu no-arrow">
                        <NavLink to="/app/emp-dashboard/default">
                            <i className="zmdi zmdi-check-square zmdi-hc-fw" />
                            <span className="nav-text">
                                <IntlMessages id="sidebar.agile.dashboard.employee" />
                            </span>
                        </NavLink>
                    </li>
                </ul>
            </li>

            <li className="menu no-arrow">
                <NavLink to="/app/employee/default">
                    <i className="zmdi zmdi-account-o zmdi-hc-fw" />
                    <span className="nav-text">
                        <IntlMessages id="orgDashboard.employees" />
                    </span>
                </NavLink>
            </li>
            <li className="menu no-arrow">
                <NavLink to="/app/portfolio/default">
                    <i className="zmdi zmdi-view-dashboard zmdi-hc-fw" />
                    <span className="nav-text">
                        <IntlMessages id="sidebar.portfolios" />
                    </span>
                </NavLink>
            </li>
            <li className="menu no-arrow">
                <NavLink to="/app/valueStream/default">
                    <i className="zmdi zmdi-view-dashboard zmdi-hc-fw" />
                    <span className="nav-text">
                        <IntlMessages id="sidebar.valueStreams" />
                    </span>
                </NavLink>
            </li>
            <li className="menu no-arrow">
                <NavLink to="/app/product/default">
                    <i className="zmdi zmdi-view-dashboard zmdi-hc-fw" />
                    <span className="nav-text">
                        <IntlMessages id="sidebar.products" />
                    </span>
                </NavLink>
            </li>
            <li className="menu no-arrow">
                <NavLink to="/app/initiative/default">
                    <i className="zmdi zmdi-view-dashboard zmdi-hc-fw" />
                    <span className="nav-text">
                        <IntlMessages id="sidebar.initiatives" />
                    </span>
                </NavLink>
            </li>
            <li className="menu no-arrow">
                <NavLink to="/app/feature/default">
                    <i className="zmdi zmdi-view-dashboard zmdi-hc-fw" />
                    <span className="nav-text">
                        <IntlMessages id="sidebar.features" />
                    </span>
                </NavLink>
            </li>
            <li className="menu">
                <a role="button" href="javascript:void(0)" onClick={(e) => this.linkClick(e)}>
                    <i className="zmdi zmdi-menu zmdi-hc-fw" />
                    <span className="nav-text">
                        <IntlMessages id="orgDashboard.projects" />
                    </span>
                </a>
                <ul className="sub-menu">
                    <li className="menu no-arrow">
                        <NavLink to="/app/project/default">
                            <i className="zmdi zmdi-storage zmdi-hc-fw" />
                            <span className="nav-text">
                                <IntlMessages id="orgDashboard.projects" />
                            </span>
                        </NavLink>
                    </li>
                    <li className="menu no-arrow">
                        <NavLink to="/app/projectBusPriority/default">
                            <i className="zmdi zmdi-view-dashboard zmdi-hc-fw" />
                            <span className="nav-text">
                                <IntlMessages id="sidebar.projectBusPrioritys" />
                            </span>
                        </NavLink>
                    </li>
                    <li className="menu no-arrow">
                        <NavLink to="/app/projectCostPriority/default">
                            <i className="zmdi zmdi-view-dashboard zmdi-hc-fw" />
                            <span className="nav-text">
                                <IntlMessages id="sidebar.projectCostPrioritys" />
                            </span>
                        </NavLink>
                    </li>
                </ul>
            </li>
            <li className="menu no-arrow">
                <NavLink to="/app/issue/default">
                    <i className="zmdi zmdi-view-dashboard zmdi-hc-fw" />
                    <span className="nav-text">
                        <IntlMessages id="sidebar.issues" />
                    </span>
                </NavLink>
            </li>
            <li className="menu">
                <a role="button" href="javascript:void(0)" onClick={(e) => this.linkClick(e)}>
                    <i className="zmdi zmdi-menu zmdi-hc-fw" />
                    <span className="nav-text">
                        <IntlMessages id="sidebar.teams" />
                    </span>
                </a>
                <ul className="sub-menu">
                    <li className="menu no-arrow">
                        <NavLink to="/app/team/default">
                            <i className="zmdi zmdi-view-dashboard zmdi-hc-fw" />
                            <span className="nav-text">
                                <IntlMessages id="sidebar.teams" />
                            </span>
                        </NavLink>
                    </li>
                    <li className="menu no-arrow">
                        <NavLink to="/app/member/default">
                            <i className="zmdi zmdi-view-dashboard zmdi-hc-fw" />
                            <span className="nav-text">
                                <IntlMessages id="sidebar.members" />
                            </span>
                        </NavLink>
                    </li>
                </ul>
            </li>
            <li className="menu">
                <a role="button" href="javascript:void(0)" onClick={(e) => this.linkClick(e)}>
                    <i className="zmdi zmdi-menu zmdi-hc-fw" />
                    <span className="nav-text">
                        <IntlMessages id="sidebar.lookups" />
                    </span>
                </a>
                <ul className="sub-menu">
                    <li className="menu no-arrow">
                        <NavLink to="/app/security/default">
                            <i className="zmdi zmdi-view-dashboard zmdi-hc-fw" />
                            <span className="nav-text">
                                <IntlMessages id="sidebar.securitys" />
                            </span>
                        </NavLink>
                    </li>
                    <li className="menu no-arrow">
                        <NavLink to="/app/businessUnit/default">
                            <i className="zmdi zmdi-view-dashboard zmdi-hc-fw" />
                            <span className="nav-text">
                                <IntlMessages id="sidebar.businessUnits" />
                            </span>
                        </NavLink>
                    </li>
                </ul>
            </li>
            <li className="menu">
                <a role="button" href="javascript:void(0)" onClick={(e) => this.linkClick(e)}>
                    <i className="zmdi zmdi-menu zmdi-hc-fw" />
                    <span className="nav-text">
                        <IntlMessages id="orgDashboard.surveys" />
                    </span>
                </a>
                <ul className="sub-menu">
                    <li className="menu no-arrow">
                        <NavLink to="/app/org-survey/default">
                            <i className="zmdi zmdi-chart zmdi-hc-fw" />
                            <span className="nav-text">
                                <IntlMessages id="orgDashboard.surveys" />
                            </span>
                        </NavLink>
                    </li>
                    <li className="menu no-arrow">
                        <NavLink to="/app/org-survey-compare/default">
                            <i className="zmdi zmdi-chart zmdi-hc-fw" />
                            <span className="nav-text">
                                <IntlMessages id="orgDashboard.compareSurveys" />
                            </span>
                        </NavLink>
                    </li>
                </ul>
            </li>
        </Fragment>
    );
};

export default SidenavAdminContent;



// WEBPACK FOOTER //
// ./containers/SideNav/SidenavAdminContent.js